const updates = [
  {
    time: '10分钟前',
    tag: '快讯',
    tagColor: 'bg-primary-100 text-primary-600',
    content: '某知名导演新片拍摄现场突发状况，剧组紧急暂停拍摄，疑似主演与导演发生激烈争执。',
  },
  {
    time: '28分钟前',
    tag: '更新',
    tagColor: 'bg-accent-100 text-accent-700',
    content: '今日吃瓜热度榜实时更新："顶流约会"事件票数突破90万，蝉联榜首位置。',
  },
  {
    time: '1小时前',
    tag: '爆料',
    tagColor: 'bg-primary-100 text-primary-600',
    content: '网友投稿：某综艺节目录制现场疑似出现选手互殴事件，节目组尚未回应。',
  },
  {
    time: '2小时前',
    tag: '快讯',
    tagColor: 'bg-primary-100 text-primary-600',
    content: '多位知名博主联合发声，揭露某MCN机构压榨签约主播内幕，引发业界震动。',
  },
  {
    time: '3小时前',
    tag: '更新',
    tagColor: 'bg-accent-100 text-accent-700',
    content: '焦点专题"七月吃瓜特辑"阅读量突破150万，成为本月最受欢迎专题内容。',
  },
  {
    time: '4小时前',
    tag: '票选',
    tagColor: 'bg-accent-100 text-accent-700',
    content: '年度梗王大选投票人数突破50万，十六位候选人之间的差距正在拉大。',
  },
  {
    time: '5小时前',
    tag: '爆料',
    tagColor: 'bg-primary-100 text-primary-600',
    content: '独家：某流量小生被拍到深夜出入某知名会所，经纪人回应称"正常社交"。',
  },
  {
    time: '6小时前',
    tag: '快讯',
    tagColor: 'bg-primary-100 text-primary-600',
    content: '某选秀节目制作方被曝拖欠选手劳务费，多名参赛者联合维权。',
  },
  {
    time: '8小时前',
    tag: '更新',
    tagColor: 'bg-accent-100 text-accent-700',
    content: '平台新增"吃瓜日报"栏目上线，每日早间推送昨日最热吃瓜事件汇总。',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-primary-500 tracking-wider uppercase mb-3 whitespace-nowrap">
            Live Updates
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            实时快讯
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div key={i} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[29px] md:-left-[33px] top-1 w-4 h-4 rounded-full bg-background-50 border-2 border-primary-400"></div>
                <div className="bg-background-50 rounded-2xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-200/70 cursor-pointer">
                  <div className="flex items-center gap-3 mb-2">
                    <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}